import { Paths, ProjectPathParams } from '../../../../../app/router/app.router';
import { KnownSortOrder } from '@groundfloor-platform/mgmt-service-g-sdk';
import {
  InfiniteScrollProps,
  InfiniteTable,
  PaginatedRow
} from '../../../../../ui/components/pure/list-table-wrappers/infinite-table.component';

import { useDeliveriesRequiringAttentionTable } from '../hooks/use-deliveries-requiring-attention-table.hook';

import { useCallback } from 'react';
import { mapDeliveryDtoToDetailsPageUrl } from '../logic/deliveries-requiring-attention-list-props.map';
import { Delivery } from '../../../../deliveries/models/delivery.model';

interface DeliveriesTableProps {
  params: ProjectPathParams<Paths.deliveries>;
  pages: PaginatedRow<Delivery>[];
  infiniteScroll: InfiniteScrollProps;
  setFormData: (update: any) => void;
  sortData: { sortBy: string; sortOrder: KnownSortOrder };
  isLoading: boolean;
  isPreviousData: boolean;
  hasError: boolean;
}

export const DeliveriesRequiringAttentionTable = ({
  params,
  pages,
  infiniteScroll,
  setFormData,
  sortData,
  isLoading,
  isPreviousData,
  hasError
}: DeliveriesTableProps) => {
  const tb = useDeliveriesRequiringAttentionTable(params.projectID);

  const mapRowURL = useCallback(
    (row: Delivery) => mapDeliveryDtoToDetailsPageUrl(row, params.shortcode || params.projectID),
    [params.projectID, params.shortcode]
  );

  tb.config({ mapRowURL });

  return (
    <InfiniteTable
      uniqueKey={'id'}
      onSort={setFormData}
      sortData={sortData}
      table={tb}
      hasError={hasError}
      pages={pages}
      infiniteScroll={infiniteScroll}
      isLoading={isLoading}
      isPreviousData={isPreviousData}
    />
  );
};
